import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["VueMarkdown"], {
    source: $props.source.replace(new RegExp('\\\\n','g'),'\n')
  }, null, 8 /* PROPS */, ["source"]))
}